import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const loyaltyLionPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('loyaltylion:customer:received', () =>
    ampli.partnerIntegrationsWidgetLoyaltyLionCustomerReceived(),
  );

  partnerEvents.on('loyaltylion:add:points:succeeded', () =>
    ampli.partnerIntegrationsWidgetLoyaltyLionAddPointsSucceeded(),
  );

  partnerEvents.on('loyaltylion:add:points:failed', () =>
    ampli.partnerIntegrationsWidgetLoyaltyLionAddPointsFailed(),
  );

  partnerEvents.on('loyaltylion:remove:points:succeeded', () =>
    ampli.partnerIntegrationsWidgetLoyaltyLionRemovePointsSucceeded(),
  );

  partnerEvents.on('loyaltylion:remove:points:failed', () =>
    ampli.partnerIntegrationsWidgetLoyaltyLionRemovePointsFailed(),
  );
};
